import React, { useState } from 'react';
import Loading from '../components/Loading';
import { getMuhuratReading, isGeminiReady } from '../services/geminiService';
import { useLanguage } from '../context/LanguageContext';

const muhuratTypes = [
  { id: 'wedding', icon: '💒', key: 'muhuratWedding' },
  { id: 'business', icon: '💼', key: 'muhuratBusiness' },
  { id: 'travel', icon: '✈️', key: 'muhuratTravel' },
  { id: 'housewarming', icon: '🏠', key: 'muhuratHousewarming' },
  { id: 'vehicle', icon: '🚗', key: 'muhuratVehicle' },
  { id: 'education', icon: '📚', key: 'muhuratEducation' },
  { id: 'namingCeremony', icon: '👶', key: 'muhuratNaming' },
  { id: 'investment', icon: '💰', key: 'muhuratInvestment' },
  { id: 'medical', icon: '🏥', key: 'muhuratMedical' },
  { id: 'spiritual', icon: '🙏', key: 'muhuratSpiritual' },
];

export default function Muhurat() {
  const { language, t } = useLanguage();
  const [selectedType, setSelectedType] = useState('');
  const [dateRange, setDateRange] = useState({
    start: new Date().toISOString().split('T')[0],
    end: new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], // 90 days
  });
  const [zodiacSign, setZodiacSign] = useState('');
  const [reading, setReading] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleFindMuhurat = async () => {
    if (!selectedType) {
      setError(t('selectMuhuratType'));
      return;
    }
    if (!isGeminiReady()) {
      setError(t('apiKeyError'));
      return;
    }
    setLoading(true);
    setError('');
    setReading('');
    try {
      const result = await getMuhuratReading(
        selectedType,
        dateRange.start,
        dateRange.end,
        zodiacSign,
        language
      );
      setReading(result);
    } catch (err) {
      setError(err.message || 'Failed to find muhurat.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="container">
        <div className="page-header">
          <h2>{t('muhuratTitle')}</h2>
          <p>{t('muhuratDesc')}</p>
        </div>

        {/* Muhurat Type Selection */}
        <div className="muhurat-types">
          <h3>{t('selectActivity')}</h3>
          <div className="muhurat-grid">
            {muhuratTypes.map(type => (
              <button
                key={type.id}
                className={`muhurat-card ${selectedType === type.id ? 'selected' : ''}`}
                onClick={() => setSelectedType(type.id)}
              >
                <span className="muhurat-icon">{type.icon}</span>
                <span className="muhurat-name">{t(type.key)}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Date Range */}
        <div className="form-section">
          <h3>{t('selectDateRange')}</h3>
          <div className="form-row">
            <div className="form-group">
              <label>{t('fromDate')}</label>
              <input
                type="date"
                value={dateRange.start}
                onChange={(e) => setDateRange(prev => ({ ...prev, start: e.target.value }))}
              />
            </div>
            <div className="form-group">
              <label>{t('toDate')}</label>
              <input
                type="date"
                value={dateRange.end}
                onChange={(e) => setDateRange(prev => ({ ...prev, end: e.target.value }))}
              />
            </div>
          </div>
        </div>

        {/* Optional Zodiac */}
        <div className="form-section">
          <div className="form-group">
            <label>{t('yourZodiacOptional')}</label>
            <select value={zodiacSign} onChange={(e) => setZodiacSign(e.target.value)}>
              <option value="">{t('selectZodiac')}</option>
              <option value="Aries">Aries (Mesha)</option>
              <option value="Taurus">Taurus (Vrishabha)</option>
              <option value="Gemini">Gemini (Mithuna)</option>
              <option value="Cancer">Cancer (Karka)</option>
              <option value="Leo">Leo (Simha)</option>
              <option value="Virgo">Virgo (Kanya)</option>
              <option value="Libra">Libra (Tula)</option>
              <option value="Scorpio">Scorpio (Vrishchika)</option>
              <option value="Sagittarius">Sagittarius (Dhanu)</option>
              <option value="Capricorn">Capricorn (Makara)</option>
              <option value="Aquarius">Aquarius (Kumbha)</option>
              <option value="Pisces">Pisces (Meena)</option>
            </select>
          </div>
        </div>

        {/* Find Muhurat Button */}
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <button className="btn btn-primary" onClick={handleFindMuhurat} disabled={loading}>
            {loading ? t('findingMuhurat') : t('findAuspiciousDates')}
          </button>
        </div>

        {loading && <Loading message={t('loadingMuhurat')} />}
        {error && <div className="error-message">{error}</div>}

        {reading && (
          <div className="result-container">
            <div className="result-card">
              <h3>📅 {t('muhuratResult')}</h3>
              <div className="content">{reading}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
